import React from "react";
import { Link } from "react-router-dom";

import s from "./nowplaying.module.scss";
import Loading from "../Loading";
import useFetch from "../../hooks/useFetch";
import {
  BACKDROP_URL,
  BACKDROP_NOT_FOUND,
  API_KEY,
} from "../../utils/constants";
import { LazyLoadImage } from "react-lazy-load-image-component";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper/core";
SwiperCore.use([Autoplay, Pagination]);

const NowPlaying = () => {
  const url = `movie/now_playing?api_key=${API_KEY}&language=en-US`;
  const { data, isLoading } = useFetch(url);

  return (
    <Loading loading={isLoading} isHalf>
      <div className="fade_in">
        <Swiper
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          pagination={{
            dynamicBullets: true,
          }}
        >
          {data.results?.map((movie) => {
            const { id, title, overview, backdrop_path } = movie;
            return (
              <SwiperSlide key={id}>
                <div className={s.item}>
                  <LazyLoadImage
                    effect="blur"
                    src={
                      backdrop_path
                        ? BACKDROP_URL + backdrop_path
                        : BACKDROP_NOT_FOUND
                    }
                    alt={title || "movie"}
                  />
                </div>
                <div className={s.info_outer}>
                  <div className={s.info_inner}>
                    <div className={s.title}>{title}</div>
                    {overview ? (
                      <div className={s.overview}>
                        {`${overview.substring(0, 200)}...`}
                      </div>
                    ) : null}
                    <div className={s.link_wrapper}>
                      <Link
                        to={`/movie/${id}`}
                        style={{ backgroundColor: "rgb(25, 118, 210)" }}
                      >
                        Details
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </Loading>
  );
};

export default NowPlaying;
